import { Stack, Text, Title, Paper, Center, Box } from '@mantine/core';
import { AlertTriangle, Mail } from 'react-feather';

/** MED-1307 (MDF-184): why the participant sees this page. */
export type FeaturesDisabledReason = 'features_disabled' | 'app_access_disabled';

const COPY: Record<FeaturesDisabledReason, { title: string; body: string }> = {
  features_disabled: {
    title: 'Features Disabled',
    body: "This cohort's features are currently disabled in Medley. If you believe you've reached this page in error, please reach out to your Medley contact.",
  },
  app_access_disabled: {
    title: 'This program runs by email',
    body: 'Your session invites, reminders, and surveys come to your inbox. For questions, reply to any program email.',
  },
};

export function FeaturesDisabledPage({
  reason = 'features_disabled',
}: {
  reason?: FeaturesDisabledReason;
}) {
  const copy = COPY[reason];
  const Icon = reason === 'app_access_disabled' ? Mail : AlertTriangle;

  return (
    <Center mih="60vh" px="md">
      <Paper p="xl" radius="md" withBorder maw={520}>
        <Stack align="center" gap="md">
          <Box
            style={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              backgroundColor: 'var(--mantine-color-gray-1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon size={28} color="var(--mantine-color-gray-6)" />
          </Box>
          <Title order={1} size="h4" ta="center">
            {copy.title}
          </Title>
          <Text size="sm" c="dimmed" ta="center" maw={400}>
            {copy.body}
          </Text>
        </Stack>
      </Paper>
    </Center>
  );
}
